import { render } from "./OrderInterface.vue?vue&type=template&id=070b81cd&scoped=true"
import script from "./OrderInterface.vue?vue&type=script&lang=js"
export * from "./OrderInterface.vue?vue&type=script&lang=js"

import "./OrderInterface.vue?vue&type=style&index=0&id=070b81cd&scoped=true&lang=css"

import exportComponent from "/home/cleanbee/web/admin.cleanbee.lt/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070b81cd"]])

export default __exports__